import { Button } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Error(props: any){
    let navigate = useNavigate();

    return (
        <>
            <div className="w-100 ">
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw] pt-10">
                    <div className="grid grid-cols-12 gap-5 gap-y-6 pb-9">
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                            <p className="text-center w-full mb-10">
                                <span className="text-2xl font-semibold">Hi! You have hit a fork in the road. Please call 888-270-0025 to continue your insurance journey.</span>
                            </p>
                            <p className="m-auto w-full text-center">
                                <Button variant="contained"  className="btn-continue hover:cursor-pointer mt-10 w-1/4" onClick={()=>{ 
                                    var searchParams = new URLSearchParams(window.location.search);
                                    var redirect = searchParams.get("returnUrl") ?? "";
                                    searchParams.delete("returnUrl");
                                    var querystring = searchParams.toString();

                                    navigate((redirect ?? "/")+"?"+querystring);
                                }}>Go Back</Button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Error;